import { render, staticRenderFns } from "./program-finance.vue?vue&type=template&id=a6b8a418&"
import script from "./program-finance.vue?vue&type=script&lang=ts&"
export * from "./program-finance.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports